/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 82a6ef6c0fcd9478a52af3dfdbb01112 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CarIe30DayPageQueryVariables = {
    country: string;
    code: string;
};
export type CarIe30DayPageQueryResponse = {
    readonly viewer: {
        readonly product: {
            readonly " $fragmentRefs": FragmentRefs<"ProductTheme_product">;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ProductCustomerService_viewer" | "BaseLayout_viewer">;
    };
};
export type CarIe30DayPageQuery = {
    readonly response: CarIe30DayPageQueryResponse;
    readonly variables: CarIe30DayPageQueryVariables;
};



/*
query CarIe30DayPageQuery(
  $country: String!
  $code: String!
) {
  viewer {
    ...ProductCustomerService_viewer_1vRKRZ
    product: websiteMarketingProductByCodeAndCountryCode(code: $code, countryCode: $country) {
      ...ProductTheme_product
    }
    ...BaseLayout_viewer_1vRKRZ
  }
}

fragment BaseLayout_viewer_1vRKRZ on Viewer {
  ...SessionLayout_viewer
  ...Header_viewer_1vRKRZ
  ...Footer_viewer_1vRKRZ
}

fragment DesktopHeader_categories on WebsiteMarketingProductCategory {
  name
  products {
    ...DesktopSubmenu_products
  }
}

fragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {
  ...ProductTheme_product
  name
  code
}

fragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {
  name
  code
  shortDescription
}

fragment DesktopSubmenu_products on WebsiteMarketingProduct {
  name
  isComingSoon
  ...DesktopSubmenuProduct_product
  ...DesktopSubmenuPlaceholder_product
}

fragment FooterCountryPicker_viewer on Viewer {
  countries: visibleCountriesByPlatform(platform: WEBSITE) {
    id
    countryAlpha2
    displayName
  }
}

fragment Footer_viewer_1vRKRZ on Viewer {
  ...FooterCountryPicker_viewer
  countryByCode(code: $country) {
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment Header_viewer_1vRKRZ on Viewer {
  countryByCode(code: $country) {
    websiteMarketingProductCategories {
      ...DesktopHeader_categories
    }
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment MenuSections_sections on WebsiteNavigationSection {
  __typename
  ... on MarketingProductWebsiteNavigationSection {
    productCategory {
      name
      products {
        name
        code
        isComingSoon
      }
    }
  }
  ... on SimpleWebsiteNavigationSection {
    name
    links {
      title
      href
      label
    }
  }
}

fragment ProductCustomerService_viewer_1vRKRZ on Viewer {
  countryByCode(code: $country) {
    salesNumber
    formattedSalesNumber
    enquiryNumber
    formattedEnquiryNumber
    supportEmail
    openingHours {
      monday {
        isClosed
        times {
          start
          end
        }
      }
      tuesday {
        isClosed
        times {
          start
          end
        }
      }
      wednesday {
        isClosed
        times {
          start
          end
        }
      }
      thursday {
        isClosed
        times {
          start
          end
        }
      }
      friday {
        isClosed
        times {
          start
          end
        }
      }
      saturday {
        isClosed
        times {
          start
          end
        }
      }
      sunday {
        isClosed
        times {
          start
          end
        }
      }
    }
    id
  }
}

fragment ProductTheme_product on WebsiteMarketingProduct {
  color
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "code",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  },
  {
    "kind": "Variable",
    "name": "countryCode",
    "variableName": "country"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  }
],
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isClosed",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "times",
    "storageKey": null,
    "args": null,
    "concreteType": "OpeningHoursRange",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "start",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "end",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isComingSoon",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CarIe30DayPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "product",
            "name": "websiteMarketingProductByCodeAndCountryCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "WebsiteMarketingProduct",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProductTheme_product",
                "args": null
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ProductCustomerService_viewer",
            "args": (v2/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "BaseLayout_viewer",
            "args": (v2/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CarIe30DayPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "countryByCode",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "code",
                "variableName": "country"
              }
            ],
            "concreteType": "Country",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "salesNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "formattedSalesNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "enquiryNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "formattedEnquiryNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "supportEmail",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "openingHours",
                "storageKey": null,
                "args": null,
                "concreteType": "CountryOpeningHours",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "monday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tuesday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "wednesday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "thursday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "friday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "saturday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sunday",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OpeningHours",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  }
                ]
              },
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteMarketingProductCategories",
                "storageKey": null,
                "args": null,
                "concreteType": "WebsiteMarketingProductCategory",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WebsiteMarketingProduct",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shortDescription",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteNavigationSections",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "MarketingProductWebsiteNavigationSection",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productCategory",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WebsiteMarketingProductCategory",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "products",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WebsiteMarketingProduct",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "SimpleWebsiteNavigationSection",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "links",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SimpleWebsiteNavigationLink",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "href",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "product",
            "name": "websiteMarketingProductByCodeAndCountryCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "WebsiteMarketingProduct",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "session",
            "storageKey": null,
            "args": null,
            "concreteType": "Session",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "countries",
            "name": "visibleCountriesByPlatform",
            "storageKey": "visibleCountriesByPlatform(platform:\"WEBSITE\")",
            "args": [
              {
                "kind": "Literal",
                "name": "platform",
                "value": "WEBSITE"
              }
            ],
            "concreteType": "Country",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "countryAlpha2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayName",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CarIe30DayPageQuery",
    "id": null,
    "text": "query CarIe30DayPageQuery(\n  $country: String!\n  $code: String!\n) {\n  viewer {\n    ...ProductCustomerService_viewer_1vRKRZ\n    product: websiteMarketingProductByCodeAndCountryCode(code: $code, countryCode: $country) {\n      ...ProductTheme_product\n    }\n    ...BaseLayout_viewer_1vRKRZ\n  }\n}\n\nfragment BaseLayout_viewer_1vRKRZ on Viewer {\n  ...SessionLayout_viewer\n  ...Header_viewer_1vRKRZ\n  ...Footer_viewer_1vRKRZ\n}\n\nfragment DesktopHeader_categories on WebsiteMarketingProductCategory {\n  name\n  products {\n    ...DesktopSubmenu_products\n  }\n}\n\nfragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {\n  ...ProductTheme_product\n  name\n  code\n}\n\nfragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {\n  name\n  code\n  shortDescription\n}\n\nfragment DesktopSubmenu_products on WebsiteMarketingProduct {\n  name\n  isComingSoon\n  ...DesktopSubmenuProduct_product\n  ...DesktopSubmenuPlaceholder_product\n}\n\nfragment FooterCountryPicker_viewer on Viewer {\n  countries: visibleCountriesByPlatform(platform: WEBSITE) {\n    id\n    countryAlpha2\n    displayName\n  }\n}\n\nfragment Footer_viewer_1vRKRZ on Viewer {\n  ...FooterCountryPicker_viewer\n  countryByCode(code: $country) {\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment Header_viewer_1vRKRZ on Viewer {\n  countryByCode(code: $country) {\n    websiteMarketingProductCategories {\n      ...DesktopHeader_categories\n    }\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment MenuSections_sections on WebsiteNavigationSection {\n  __typename\n  ... on MarketingProductWebsiteNavigationSection {\n    productCategory {\n      name\n      products {\n        name\n        code\n        isComingSoon\n      }\n    }\n  }\n  ... on SimpleWebsiteNavigationSection {\n    name\n    links {\n      title\n      href\n      label\n    }\n  }\n}\n\nfragment ProductCustomerService_viewer_1vRKRZ on Viewer {\n  countryByCode(code: $country) {\n    salesNumber\n    formattedSalesNumber\n    enquiryNumber\n    formattedEnquiryNumber\n    supportEmail\n    openingHours {\n      monday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      tuesday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      wednesday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      thursday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      friday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      saturday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n      sunday {\n        isClosed\n        times {\n          start\n          end\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ProductTheme_product on WebsiteMarketingProduct {\n  color\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2801fde234baf9278cf6dd1714cc5625';
export default node;
